<nav id="sidebar" class="{{active ? 'active' : ''}}">
  <div class="sidebar__content">
    <figure>
      <img src="/assets/images/logo.svg" alt="">
      <button class="{{active ? 'show' : 'hide'}}" (click)="showSidebar()"><img src="/assets/images/icon-close.svg"
          alt=""></button>
    </figure>
    <h2>Versiones terminos y condiciones</h2>
    <div class="sidebar__items">
      <p>
        <a href="/terminos-condiciones">Version Actual</a>
        <small>10 de Noviembre de 2023</small>
      </p>
      <p>
        <a href="/terminos-condiciones-version-1.0">Version 1.0</a>
        <small>03 de Julio de 2020</small>
      </p>
    </div>
  </div>
</nav>